import type { Globals } from './globals';

function getErrorMessage(globals: Globals, err: unknown): string {
  if (err instanceof globals.BABYLON.RuntimeError) {
    return String((err.innerError || err).message);
  }
  if (err instanceof Error) {
    return String(err.message);
  }
  return String(err);
}

export function loggerError(globals: Globals, err: unknown): void {
  globals.BABYLON.Logger.Error(getErrorMessage(globals, err));
}

export interface LoggerOptions {
  onError?: (message: string, level: number) => void;
}

function parseErrorEntry(globals: Globals, entry: string): { message: string; level: number } {
  // cf. https://github.com/BabylonJS/Babylon.js/blob/5.50.1/packages/dev/core/src/Misc/logger.ts
  const m = /^<div style='color:(.*?)'>(.*?)<\/div><br>$/.exec(entry);
  if (m) {
    return {
      message: m[2] || '',
      level:
        globals.BABYLON.Logger[
          // eslint-disable-next-line no-nested-ternary
          m[1] === 'white'
            ? 'MessageLogLevel'
            : m[1] === 'orange'
            ? 'WarningLogLevel'
            : 'ErrorLogLevel'
        ],
    };
  }
  return { message: entry.replace(/<[^>]*>/g, ''), level: globals.BABYLON.Logger.ErrorLogLevel };
}

export function updateLogger(globals: Globals, { onError }: LoggerOptions = {}): void {
  // eslint-disable-next-line no-param-reassign
  globals.BABYLON.Logger.OnNewCacheEntry = (entry): void => {
    if (onError) {
      const parsed = parseErrorEntry(globals, entry);
      onError(parsed.message, parsed.level);
    }
  };
}
